import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MeService, ViewSidenavComponent } from 'ad4core';
import { filter } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [ViewSidenavComponent]
})
export class AppComponent {

  public isIframe: boolean = false;

  constructor(
    public me: MeService, private swUpdate: SwUpdate, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer
  ) {

    // set application version
    this.me.setApplication("ad4wine", "3.3");

    // add social icons
    iconRegistry.addSvgIcon('facebook', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/facebook.svg'));
    iconRegistry.addSvgIcon('facebook-messenger', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/facebook-messenger.svg'));
    iconRegistry.addSvgIcon('instagram', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/instagram.svg'));
    iconRegistry.addSvgIcon('linkedin', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/linkedin.svg'));
    iconRegistry.addSvgIcon('pinterest', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/pinterest.svg'));
    iconRegistry.addSvgIcon('tiktok', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/tiktok.svg'));
    iconRegistry.addSvgIcon('twitter', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/twitter.svg'));
    iconRegistry.addSvgIcon('twitterx', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/twitterx.svg'));
    iconRegistry.addSvgIcon('whatsapp', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/whatsapp.svg'));
    iconRegistry.addSvgIcon('youtube', sanitizer.bypassSecurityTrustResourceUrl('/assets/social/youtube.svg'));

  }

  async ngOnInit(): Promise<void> {

    // if we are running within iFrame, do not show any UI - MSAL acquireTokenSilent
    this.isIframe = window !== window.parent && !window.opener;

    // me service initialization
    await this.me.OnAppInit();

    // reload for new service worker to take effect
    if (this.swUpdate.isEnabled) {

      // Check for available updates
      this.swUpdate.versionUpdates.pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      ).subscribe(evt => {

        console.log('New version available. Current version:', evt.currentVersion.hash, 'Available version:', evt.latestVersion.hash);

        // Reload the page to activate the new service worker
        window.location.reload();

      });
    }

  }

  ngOnDestroy(): void {

    this.me.OnAppDestroy();

  }


}
